module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('title-user', [_vm._v("\n        Comprovantes\n        "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Comprovante " + _vm._s(_vm.$route.params.orderId) + "\n      ")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "opacity": true
      }
    }],
    staticClass: "form-box margin-t20"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('img', {
    staticClass: "rule-color",
    attrs: {
      "src": require("../../../../static/email/signature/rule_color.png"),
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "title-toll-left upper bold"
  }, [_vm._v("dados da conta debitada")]), _vm._v(" "), _c('p', {
    staticClass: "title-toll-right"
  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-toll-right"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "three-dots bold margin-l5"
  }, [_vm._v(_vm._s(_vm.dataTransfer.nomeDebito) + "  ")]), _vm._v(" "), _c('p', {
    staticClass: "three-dots bold margin-l5"
  }, [_vm._v(_vm._s(_vm.dataTransfer.contractIdDeb) + "  ")]), _vm._v(" "), _c('p', {
    staticClass: "three-dots bold margin-l5"
  }, [_vm._v(_vm._s(_vm._f("dateTime")(_vm.dataTransfer.dataTransfer)) + "  ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-t20"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "title-doc-left upper bold"
  }, [_vm._v("dados da conta creditada")]), _vm._v(" "), _c('p', {
    staticClass: "title-doc-right credit"
  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "box-doc-right"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "three-dots bold margin-l5"
  }, [_vm._v(_vm._s(_vm.dataTransfer.nomeCredito) + "  ")]), _vm._v(" "), _c('p', {
    staticClass: "three-dots bold margin-l5"
  }, [_vm._v(_vm._s(_vm.dataTransfer.contractIdCred) + "  ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-t20"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "title-value-left upper bold"
  }, [_vm._v("valor")]), _vm._v(" "), _c('p', {
    staticClass: "title-value-right"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "three-dots text-center bold value-receipt"
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.dataTransfer.transferValue)) + "  ")])])]), _vm._v(" "), _c('p', {
    staticClass: "no-margin"
  }, [_vm._v("   ")])])]), _vm._v(" "), _c('p', {
    staticClass: "number-receipt"
  }, [_vm._v("Identificador de controle: " + _vm._s(_vm.$route.params.orderId))]), _vm._v(" "), _c('p', {
    staticClass: "no-margin"
  }, [_vm._v("   ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row hidden-print"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "margin-t20"
  }, [_c('div', {
    staticClass: "back-button-box"
  }, [_c('router-link', {
    staticClass: "btn btn-back",
    attrs: {
      "to": {
        name: 'plans'
      },
      "tag": "button"
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v("\n            Voltar\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "action-buttons-box"
  }, [_c('button', {
    staticClass: "btn btn-back",
    on: {
      "click": function($event) {
        return _vm.window.print()
      }
    }
  }, [_vm._v("\n            Imprimir\n            "), _c('i', {
    staticClass: "icon-printer align-icon-left"
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    staticClass: "logo-receipt",
    attrs: {
      "src": require("../../../../static/logo-move-mais-balance-header.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('h4', {
    staticClass: "title-receipt"
  }, [_vm._v("Comprovante de transferência de créditos")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-toll-left"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "three-dots text-right margin-r5"
  }, [_vm._v("Nome do cliente:")]), _vm._v(" "), _c('p', {
    staticClass: "three-dots text-right margin-r5"
  }, [_vm._v("N° do Contrato:")]), _vm._v(" "), _c('p', {
    staticClass: "three-dots text-right margin-r5"
  }, [_vm._v("Data da transferência:")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-doc-left"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "three-dots text-right margin-r5"
  }, [_vm._v("Nome do cliente:")]), _vm._v(" "), _c('p', {
    staticClass: "three-dots text-right margin-r5"
  }, [_vm._v("N° do Contrato:")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-636de27b!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/credit/transfer-credit-receipt.vue
// module id = 2150
// module chunks = 1